import { render, staticRenderFns } from "./ReportsDeliveryEndedView.vue?vue&type=template&id=957ae372"
import script from "./ReportsDeliveryEndedView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryEndedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports